"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHeadContext = useHeadContext;
exports.HeadProvider = HeadProvider;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeadContext = (0, _react.createContext)(null);

function useHeadContext() {
  var context = (0, _react.useContext)(HeadContext);

  if (!context) {
    throw new Error('Do not use head components outside of the HeadContext');
  }

  return context;
}

function HeadProvider(_ref) {
  var children = _ref.children,
      sticky = _ref.sticky,
      sorting = _ref.sorting;

  var value = _react2.default.useMemo(function () {
    return {
      sticky: sticky,
      sorting: sorting
    };
  }, [sorting, sticky]);

  return _react2.default.createElement(HeadContext.Provider, {
    value: value
  }, children);
}